
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export const LocalityDistribution: React.FC = () => {
  // Mock data - would be replaced with actual API data
  const data = [
    { name: 'San Salvador', value: 35 },
    { name: 'Humahuaca', value: 15 },
    { name: 'Tilcara', value: 20 },
    { name: 'Purmamarca', value: 10 },
    { name: 'Otras', value: 20 },
  ];
  
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8'];
  
  const config = {};
  data.forEach((entry, index) => {
    config[entry.name] = {
      label: entry.name,
      color: COLORS[index % COLORS.length],
    };
  });

  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Distribución por Localidad</CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <ChartContainer className="aspect-video h-64" config={config}>
          <>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <ChartTooltip
                  content={
                    <ChartTooltipContent nameKey="name" labelKey="value" />
                  }
                />
              </PieChart>
            </ResponsiveContainer>
          </>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
